import { render, staticRenderFns } from "./Doctor.vue?vue&type=template&id=f841bd64&scoped=true"
import script from "./Doctor.vue?vue&type=script&lang=js"
export * from "./Doctor.vue?vue&type=script&lang=js"
import style0 from "./Doctor.vue?vue&type=style&index=0&id=f841bd64&prod&lang=scss&scoped=true"
import style1 from "./Doctor.vue?vue&type=style&index=1&id=f841bd64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f841bd64",
  null
  
)

export default component.exports